import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PersonAgeStatus } from '@core/api/generated/api-client';
import { personAgeStatusLabels } from '@core/api/enums/person-age-status.labels';

@Component({
  selector: 'app-age-status-badge',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  templateUrl: './age-status-badge.component.html',
  styleUrl: './age-status-badge.component.scss'
})
export class AgeStatusBadgeComponent {
  @Input() status?: PersonAgeStatus | null;

  get label(): string | null {
    if (!this.status) return null;
    return personAgeStatusLabels[this.status] ?? this.status;
  }
}
